import React, { Suspense, useCallback, useContext, useEffect, useState } from "react";
import { getEmployeesLeaves, getLeaveBalanceListData, getYearlyWFHApplied } from "./Service/ReportService";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { TostMsg } from "../../../App";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Papa from "papaparse";
import { saveAs } from "file-saver";


function LeaveBalanceReport() {
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  const [leaveBalanceData, setLeaveBalanceData] = useState([]);

  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filteredData, setFilteredData] = useState(leaveBalanceData);

  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const defaultImage = "/images/placeholder_profile.png";
  const [selectLeaveWfh, setSelectLeaveWfh] = useState([]);
  const selectedColumns = [
    "FullName", "WFHBalance", "Planned", "Unplanned", "Paternity", "Maternity", "Hospitalization", "LWP", "SpecialDay"
  ];

  const [searchText, setSearchText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    GetMasterSystemAlertList("Leave_Report", 1);
    getLeaveBalanceList(0, rowsPerPage, "");
  }, []);


  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        // setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);

  const onSortChange = (e) => {
    setSortField(e.sortField);
    setSortOrder(e.sortOrder);

    const sortedData = [...filteredData].sort((a, b) => {
      let valueA = a[e.sortField];
      let valueB = b[e.sortField];

      if (typeof valueA === "string") valueA = valueA.toLowerCase();
      if (typeof valueB === "string") valueB = valueB.toLowerCase();

      if (valueA < valueB) return e.sortOrder;
      if (valueA > valueB) return -e.sortOrder;
      return 0;
    });

    setFilteredData(sortedData);
  };

  const onPageChange = (e) => {
    const page = e.first / e.rows;

    setCurrentPage(page);
    setRowsPerPage(e.rows);

    getLeaveBalanceList(page, e.rows, searchText);
  };

  const handleSearch = (e) => {
    const value = e.target.value;

    setSearchText(value);
    setCurrentPage(0);

    getLeaveBalanceList(0, rowsPerPage, value);
  };



    async function getLeaveBalanceList(page = 0, size = rowsPerPage, search = searchText) {
      setIsloading(true);

      var params = {
        SearchTerm: search || "",
        PageNumber: page + 1,   // API usually 1-based
        PageSize: size
      };

      try {
        let response = await getLeaveBalanceListData(params);

        setLeaveBalanceData(response?.Data || []);
        setTotalRecords(response?.Data?.[0]?.TotalCount || 0);  // IMPORTANT
        setIsloading(false);
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setIsloading(false);
      }
    }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage; // Set the fallback image on error
  }, []);

  const styleFullName = (rowData) => {
    return (
      <Link to={`/Profile/${rowData.GUID}`}>
        <div className="d-flex align-items-center">
          <img
            src={rowData?.ProfileImage || defaultImage}
            onError={handleImageError}
            className="rounded-lg me-2"
            width="24"
            alt=""
          />{" "}
          <span className="w-space-no">
            {rowData?.FullName} ({rowData?.EmpId})
          </span>
        </div>
      </Link>
    );
  };

  function exportToCSV() {
    if (selectLeaveWfh.length > 0) {

      const selectedColumns = [
        "FullName",
        "WFHBalance",
        "Planned",
        "Unplanned",
        "Paternity",
        "Maternity",
        "Hospitalization",
        "LWP",
        "SpecialDay"
      ];
      const filteredData = selectLeaveWfh.map((item) => {
        const obj = {};
        selectedColumns.forEach((col) => {
          obj[col] = item[col];
        });
        return obj;
      });
      const csv = Papa.unparse(filteredData);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "LeaveBalanceReport.csv");

    } else {
      toster.current.warn("Please select at least one employee");
    }
  }


  return (
    <div>
      <div className="container-fluid position-relative">
        <div className="row team-directories g-3">
          {/* HEADER */}
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Leave and WFH Balance Summary</h2>
                {/* <p>{masterSystemAlertData}</p> */}
                <p>Current leave balances and Work From Home (WFH) balances for employees.</p>
              </div>
              <div className="rightside-tabs">

                <Link to="/Reports">
                  <button className="back-newticket w-auto float-right">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-arrow-left-short"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                      />
                    </svg>{" "}
                    Back
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="form-head d-flex flex-wrap align-items-center mb-3">
                  <div className="me-auto">
                    {/* <strong>Records</strong> */}
                  </div>
                  <div className="actionbutton-tickets rightside-tabs">
                    <input
                      type="text"
                      className="form-control"
                      value={searchText}
                      onChange={handleSearch}
                      placeholder="Search"
                    />
                    <button
                      className="export-btn"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Export"
                      onClick={() => exportToCSV()}
                    >
                      <img
                        src="/images/excels.png"
                        alt="export"
                        style={{ width: "21px" }}
                      />
                    </button>
                  </div>
                </div>
                <div className="table-responsive">
                  <div className="table table-bordered Employeelist ">
                    <DataTable
                      value={leaveBalanceData}
                      lazy
                      paginator
                      rows={rowsPerPage}
                      first={currentPage * rowsPerPage}
                      totalRecords={totalRecords}
                      onPage={onPageChange}
                      dataKey="EmpId"
                      selection={selectLeaveWfh}
                      onSelectionChange={(e) => setSelectLeaveWfh(e.value)}
                      selectionPageOnly={false}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                      paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                      currentPageReportTemplate="{first} to {last} of {totalRecords}"

                    > 
                    <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                      <Column field="FullName" body={styleFullName} header="Name" />
                      <Column field="WFHBalance" header="WFH" />
                      <Column field="Planned" header="Planned" />
                      <Column field="Unplanned" header="Unplanned" />
                      <Column field="Paternity" header="Paternity" />
                      <Column field="Maternity" header="Maternity" />
                      <Column field="Hospitalization" header="Hospitalization" />
                      <Column field="LWP" header="LWP" />
                      <Column field="SpecialDay" header="Special Day" />
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : ("")}
    </div>
  );
}

export default LeaveBalanceReport;
